export const UserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <rect width="36" height="36" rx="18" fill="#242424" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0005 9C20.5809 9 22.6736 11.1097 22.6736 13.7134C22.6736 16.3161 20.5809 18.4257 18.0005 18.4257C15.4201 18.4257 13.3273 16.3161 13.3273 13.7134C13.3273 11.1097 15.4201 9 18.0005 9Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09853 27C8.18325 27 7.68117 25.948 8.22434 25.2052C10.4392 22.1857 13.9893 20.2228 18.0003 20.2228C22.0113 20.2228 25.5603 22.1857 27.7752 25.2052C28.3195 25.948 27.8163 27 26.901 27H9.09853Z"
        fill="white"
      />
    </svg>
  );
};
